export default "__VITE_ASSET__daff9a6a__"